(function () {
    'use strict';

    angular
        .module('app.campaign')
        .controller('IntegratedCampaignsModalController', IntegratedCampaignsModal);

    IntegratedCampaignsModal.$inject = ['providers', 'close', 'IntegratedCampaignsService'];

    function IntegratedCampaignsModal(providers, close, IntegratedCampaignsService) {
        var vm = this;
        vm.selectedPlatform = '';
        vm.processBusy = false;
        vm.success = false;

        const initialProviders = [...providers];

        vm.close = function() {
            close(vm.success, 500);
        };

        vm.selectPlatform = function(platform) {
            vm.selectedPlatform = platform;

            if (platform === 'dv360') {
                vm.tabs = [{
                    id: 'invite',
                    label: 'Invite',
                }, {
                    id: 'accounts',
                    label: 'Partners',
                }, {
                    id: 'complete',
                    label: 'Complete',
                }];
            } else if (platform === 'adwords') {
                vm.tabs = [{
                    id: 'accounts',
                    label: 'Partners',
                }, {
                    id: 'complete',
                    label: 'Complete',
                }];
            } else {
                vm.tabs = [{
                    id: 'accounts',
                    label: 'Accounts',
                }, {
                    id: 'complete',
                    label: 'Complete',
                }];
            }

            if (!vm.tabActive) {
                vm.tabActive = vm.tabs[0].id;
            }
        };

        /* ************************************************************* */
        /* **************************** Tabs *************************** */
        /* ************************************************************* */
        vm.isTabActive = id => id === vm.tabActive;
        vm.onTabSelect = id => {
            vm.tabActive = id;
            vm.tabs = vm.tabs.map(item => item.id === id ? { ...item, enable: true } : item);
        };

        vm.hasTabError = id => {
            const tab = vm.tabs.find(item => item.id === id);
            if (tab.done && id === 'clients' && !vm.clientsAvailable) {
                return true;
            }

            return false;
        };

        vm.onBack = id => vm.onTabSelect(id);
        vm.onNext = id => {
            vm.tabs = vm.tabs.map(item => (
                item.id === vm.tabActive ? {
                    ...item,
                    enable: true,
                    done: true,
                } : item
            ));

            if (id == 'complete') {
                vm.processBusy = true;
                const provider = initialProviders.find(i => i.provider === vm.selectedPlatform);
                const accountIds = vm.activeAccount ? [...vm.accounts, vm.activeAccount] : vm.accounts;
                const idToken = localStorage.getItem('idToken');

                if (provider && provider.accounts.length) {
                    IntegratedCampaignsService.update({
                        provider: vm.selectedPlatform,
                        accountIds,
                        idToken,
                    }).$promise
                        .then(() => {
                            vm.processBusy = false;
                            vm.onTabSelect(id);
                            vm.success = true;
                        });
                } else {
                    IntegratedCampaignsService.create({
                        provider: vm.selectedPlatform,
                        accountIds,
                        idToken,
                    }).$promise
                        .then(() => {
                            vm.processBusy = false;
                            vm.onTabSelect(id);
                            vm.success = true;
                        });
                }
            } else {
                vm.onTabSelect(id);
            }
        };
        vm.isNextDisabled = () => (vm.activeTab === 'accounts' && vm.accounts.length === 0) || vm.processBusy;

        vm.accounts = [];
        vm.activeAccount = "";

        vm.addAccount = () => {
            if (vm.activeAccount && !vm.accounts.find(item => item === vm.activeAccount)) {
                vm.accounts.push(vm.activeAccount);
                vm.activeAccount = "";
            }
        };

        vm.removeAccount = partner => {
            vm.accounts = vm.accounts.filter(item => item !== partner);
        };
    }
})();
